import { render, staticRenderFns } from "./FooterTreeColumn.vue?vue&type=template&id=deb68e36&scoped=true"
import script from "./FooterTreeColumn.vue?vue&type=script&lang=js"
export * from "./FooterTreeColumn.vue?vue&type=script&lang=js"
import style0 from "./FooterTreeColumn.vue?vue&type=style&index=0&id=deb68e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb68e36",
  null
  
)

export default component.exports